
import XDialog from 'vux/src/components/x-dialog/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'

import {mapState} from 'vuex'
export default{
data () {
return {}
},
components: {XDialog, Group, Cell},
created () {
this.load()
this.$store.state.bus.$on('todo-done', this.load)
},
methods: {
load () {
this.$http.get('/todo/todo/current/').then(({data}) => {
this.$store.state.todos = data.results
}).catch(e => {
console.error(e)
})
}
},
computed: {
show () {
if (this.todos.length < 1) {
return false
}
let urls = this.todos.map(a => a.url)

if (urls.includes(this.$route.path) || urls.includes(`${this.$route.path}/`)) {
return false
}
return true
},
...mapState(['todos'])
}
}



// WEBPACK FOOTER //
// ./src/views/todo/todo/components/Dialog.vue